const LANGUAGE_ALIASES = {
	"es-chl": "es",
	"es-mx": "es",
	"zh-tw": "zh-cht"
}

export const loadTranslations = async (language) => {
	const normalizedLanguage = (language || "en").toLowerCase()
	const catalogLanguage = LANGUAGE_ALIASES[normalizedLanguage] || normalizedLanguage

	try {
		const result = await import(`../../translations/${catalogLanguage}.json`)
		return result.default || result
	} catch (error) {
		if (catalogLanguage !== "en") {
			try {
				const fallback = await import("../../translations/en.json")
				return fallback.default || fallback
			} catch (fallbackError) {
				console.error("Error loading English translations:", fallbackError)
				return {}
			}
		}

		console.error("Error loading translations:", error)
		return {}
	}
}
